import { PermissionDto, RoleDto } from '@/api/generator';
import { I18nKey } from '@/utils/typings.ts';
import { Namespace, TFunction } from 'i18next';

export function createPermissionsDictionary(allPermissions: PermissionDto[]) {
  return allPermissions.reduce<Record<string, PermissionDto>>(
    (prev, curr) => ({ ...prev, [curr.id!]: curr }),
    {},
  );
}

const isCustomRole = (role: RoleDto) => {
  return role.type === 'CustomRole';
};

export const getTranslatedRoleName = (t: TFunction<Namespace, undefined>, role: RoleDto) => {
  if (isCustomRole(role)) {
    return role.displayName;
  }
  return t(role.displayName as I18nKey);
};

export const getTranslatedRoleDescritption = (
  t: TFunction<Namespace, undefined>,
  role: RoleDto,
) => {
  if (isCustomRole(role)) {
    return role.description ?? undefined;
  }
  return t(role.description as I18nKey);
};
